import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Css/Login.css";
// import logo from "../Component/Images/logo.png";
import axios from "axios";
import API_BASE from "../config/api";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        `${API_BASE}/api/Auth/login`,
        { email, password }
      );

      const { accessToken, refreshToken, role } = res.data;

      // 🚫 Block if NOT Teacher
      if (role !== "Teacher") {
        alert("Access denied. Only Teachers can log in.");
        return;
      }

      // ✅ Store tokens only if Teacher
      sessionStorage.setItem("accessToken", accessToken);
      sessionStorage.setItem("refreshToken", refreshToken);
      sessionStorage.setItem("role", role);

      // ✅ Navigate
      navigate("/dashboard");

    } catch (err) {
      alert(
        err.response?.data?.message ||
        err.response?.data ||
        "Login failed"
      );
    }
  };


  const handleForgotSubmit = (e) => {
    e.preventDefault();
    console.log("Send reset code to:", email);
    alert("A reset code has been sent to your email!");
  };



  return (
    <div className="login-container">
      {/* Left Section */}
      <div className={`login-left ${forgotPassword ? "forgot-left" : ""}`}>
        <h2>{forgotPassword ? "" : "Welcome To"}</h2>
        <div className="logo-box">
          {/* <img src={logo} alt="Logo" /> */}
        </div>

        <p>
          {forgotPassword
            ? "As an Admin, you can manage your institute efficiently - add teachers and students, review question banks, track book sales, and monitor commissions - all in one place."
            : "As a Teacher, you can view assigned exams, explore student attempt records, and analyse performance with ease."}
        </p>
      </div>

      {/* Right Section */}
      <div className={`login-right ${forgotPassword ? "forgot-right" : ""}`}>
        <div className="login-card">
          <h2>{forgotPassword ? "Forgot your Password?" : "Log In"}</h2>

          {/* Show this paragraph only when forgotPassword is true */}
          {forgotPassword && (
            <p className="text-normal" >A code will be sent to your email to help reset password</p>
          )}
          <form onSubmit={forgotPassword ? handleForgotSubmit : handleLoginSubmit}>
            <label>Email</label>
            <div className="input-box">
              <input
                type="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <span className="icon">
                {/* email icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM12 13L4 8V18H20V8L12 13ZM12 11L20 6H4L12 11ZM4 8V6V18V8Z"
                    fill="#979797"
                  />
                </svg>
              </span>
            </div>

            {!forgotPassword && (
              <>
                <label>Password</label>
                <div className="input-box">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
                          fill="#979797"
                        />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M16.1 13.2969L14.65 11.8469C14.8 11.0635 14.575 10.3302 13.975 9.64688C13.375 8.96354 12.6 8.69688 11.65 8.84688L10.2 7.39688C10.4833 7.26354 10.7708 7.16354 11.0625 7.09688C11.3542 7.03021 11.6667 6.99688 12 6.99688C13.25 6.99688 14.3125 7.43438 15.1875 8.30938C16.0625 9.18438 16.5 10.2469 16.5 11.4969C16.5 11.8302 16.4667 12.1427 16.4 12.4344C16.3333 12.726 16.2333 13.0135 16.1 13.2969ZM19.3 16.4469L17.85 15.0469C18.4833 14.5635 19.0458 14.0344 19.5375 13.4594C20.0292 12.8844 20.45 12.2302 20.8 11.4969C19.9667 9.81354 18.7708 8.47604 17.2125 7.48438C15.6542 6.49271 13.9167 5.99688 12 5.99688C11.5167 5.99688 11.0417 6.03021 10.575 6.09688C10.1083 6.16354 9.65 6.26354 9.2 6.39688L7.65 4.84688C8.33333 4.56354 9.03333 4.35104 9.75 4.20938C10.4667 4.06771 11.2167 3.99688 12 3.99688C14.5167 3.99688 16.7583 4.69271 18.725 6.08438C20.6917 7.47604 22.1167 9.28021 23 11.4969C22.6167 12.4802 22.1125 13.3927 21.4875 14.2344C20.8625 15.076 20.1333 15.8135 19.3 16.4469ZM19.8 22.5969L15.6 18.4469C15.0167 18.6302 14.4292 18.7677 13.8375 18.8594C13.2458 18.951 12.6333 18.9969 12 18.9969C9.48333 18.9969 7.24167 18.301 5.275 16.9094C3.30833 15.5177 1.88333 13.7135 1 11.4969C1.35 10.6135 1.79167 9.79271 2.325 9.03438C2.85833 8.27604 3.46667 7.59688 4.15 6.99688L1.4 4.19688L2.8 2.79688L21.2 21.1969L19.8 22.5969ZM5.55 8.39688C5.06667 8.83021 4.625 9.30521 4.225 9.82188C3.825 10.3385 3.48333 10.8969 3.2 11.4969C4.03333 13.1802 5.22917 14.5177 6.7875 15.5094C8.34583 16.501 10.0833 16.9969 12 16.9969C12.3333 16.9969 12.6583 16.976 12.975 16.9344C13.2917 16.8927 13.6167 16.8469 13.95 16.7969L13.05 15.8469C12.8667 15.8969 12.6917 15.9344 12.525 15.9594C12.3583 15.9844 12.1833 15.9969 12 15.9969C10.75 15.9969 9.6875 15.5594 8.8125 14.6844C7.9375 13.8094 7.5 12.7469 7.5 11.4969C7.5 11.3135 7.5125 11.1385 7.5375 10.9719C7.5625 10.8052 7.6 10.6302 7.65 10.4469L5.55 8.39688Z" fill="#979797" />
                      </svg>
                    )}
                  </span>
                </div>

                <div
                  className="forgot"
                  onClick={() => setForgotPassword(true)}
                  style={{ cursor: "pointer" }}
                >
                  Forgot Password?
                </div>

                <button type="submit" className="login-btn">
                  Login
                </button>
              </>
            )}

            {forgotPassword && (
              <>
                <button type="submit" className="login-btn">
                  Reset Password
                </button>
                <div className="back-text"
                  onClick={() => setForgotPassword(false)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_569_11744)">
                      <path d="M10 22.5L0 12.5L10 2.5L11.775 4.275L3.55 12.5L11.775 20.725L10 22.5Z" fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_569_11744">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg> Back to Log In
                </div>

              </>
            )}

            {!forgotPassword && (
              <>
                <div className="divider">or continue with</div>
                <p className="signup-text">
                  Don’t have an account? <span>Sign Up</span>
                </p>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
